<div class="h-body-culr">
  <app-header></app-header>
  <section class="h-row">
    <div class="row h-main-hed">
      <!-- <div class="home-mar notice-bar mb-3">
            <div class="notice-text">
                ⚠️ Scheduled Maintenance: Opinion-Edge will be temporarily unavailable on
                <strong>13 Nov 2025, 03:30 AM – 13 Nov 2025, 09:30 AM EST </strong>
            </div>
        </div> -->
      <section class="grid-item col-md-7 col-sm-12">
        <div class="h-text-box row">
          <section class="h-text-box-1 col-md-12 col-sm-12">
            <strong class="text-danger">{{'gotOpinions' | translate}}</strong>
            <div class="text-h-wrap">{{'speakYourMind' | translate}}</div>
          </section>
        </div>
        <div class="h-text-box-3 row">
          <img src="../../../assets/images/home_bg-2.png" class="historik-img" alt="bg-img">
          <!-- <section class="h-survey-daily">
            <h6>8000 +</h6>
            <p>New surveys daily</p>
          </section> -->
          <section class="home-info-box row">
            <div class="home-info-form col-md-6 col-sm-12 flex-gap">
              <h6 class="font-regular mb-0">{{'wishToJoin' | translate}} </h6>
              <div class="h-text-box-3-1">
                <div class="row join-home">
                  <!-- <div class="col-md-6 col-sm-12">
                  <div class="input-group mb-3">
                    <span class="input-group-text">
                      <mat-icon>mark_email_unread</mat-icon>
                    </span>
                    <input type="email" class="form-control" placeholder="Type you email address">
                  </div>
                </div> -->
                  <div class="col-md-12 col-sm-12" (click)="openDialog()">
                    <button>{{'joinEarn' | translate : { bonusAmount: joinBonus } }}</button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <section class="grid-item h-r-image-box col-md-5 col-sm-12">
        <section class="global-reward slide-in-br">
          <div>
            <h5>$ {{globalRewards*10 | number : '1.0-2'}} +</h5>
            <p>{{'globalRewards' | translate}}</p>
          </div>
          <div>
            <h6>{{countries}} +</h6>
            <p>{{'countries' | translate}}</p>
          </div>
        </section>
        <section class="h-r-box-1 top-leftclass col-md-3 col-sm-12 d-flex justify-content-end">
          <div class="h-responde-box flex-gap tilt-in-tr">
            <section>
              <h6>{{respondents*100 | number : '1.0-2'}} +</h6>
              <p>{{'respondents' | translate}}</p>
            </section>
            <!-- <section>
              <h6>18,000 +</h6>
              <p>Respondents</p>
            </section> -->
          </div>
        </section>
        <section class="h-daily-survey-box slide-in-tr">
          <img class="daily-survey-img" src="../../../assets/images/daily_box.webp" alt="daily-survey-box">
          <div class="h-daily-survey-text">
            <h6 class="h-font">{{liveSurveys | number : '1.0-2'}} +</h6>
            <p>{{'liveSurveys' | translate}}</p>
          </div>
        </section>
        <img src="../../../assets/images/home-img.jpg" alt="survey-img" class="h-img h-100">
      </section>
    </div>
  </section>

  <!-- About -->
  <section class="happy-row about-row">
    <div class="happy-container d-flex p-0">
      <section class="participate-hed p-4">
        <div class="happy-row-background"></div>
        <div class="hifen"></div>
        <section class="story-box">
          <div>{{'aboutUs' | translate}}</div>
          <div class="about-content flex-gap gap-3">
            <h5 class="fw-bold">{{'weGather' | translate}} <br>{{'toBring' | translate}}</h5>
            <div class="row">
              <div class="col-md-6 about-info  font-regular fs-5">
                <strong>Opinion Edge</strong> {{'isMultilingual' | translate}} <strong>{{'thirtyFiveCountries'|
                  translate}}</strong>
                {{'toConnectReal' | translate}}
              </div>

              <div class="col-md-6 about-info font-regular fs-5">
                {{'humanVerifications' | translate}}
              </div>
            </div>
            <div class="row">

              <div class="col-md-6 font-regular about-info fs-5">
                {{'withAdvance' | translate}}
              </div>

              <div class="col-md-6 about-info font-regular fs-5">
                {{'whetherYou' | translate}} <strong>{{'mobileApp' |translate}}</strong>{{'orParticipating' |
                translate}}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section class="about-img-box">
        <video #videoPlayer 
         id="video-intro-player" 
         muted 
         autoplay 
         playsinline 
         loop
         preload="metadata"
         webkit-playsinline="true">
          <source type="video/mp4" src="../../../assets/videos/about-us-info.mp4">
        </video>
      </section>
    </div>
  </section>


  <!-- Participate & earn from -->
  <section class="participate-row">
    <h4 class="participate-hed">
      <div class="hifen"></div>
      <div>{{'participateEarn' | translate}}</div>
    </h4>
    <div class="participate-content">
      <section class="participate-box">
        <mat-icon>description</mat-icon>
        <h6 class="h-font">{{'surveysTab' | translate}}</h6>
        <p>{{'eightKDailySurvey' | translate}}</p>
      </section>
      <section class="participate-box">
        <mat-icon>campaign</mat-icon>
        <h6 class="h-font">{{'_campaign' | translate}}</h6>
        <p>{{'weeeklyAndMonthly' | translate}}</p>
      </section>
      <section class="participate-box">
        <mat-icon>description</mat-icon>
        <h6 class="h-font">{{'miniSurveys' | translate}}</h6>
        <p>{{'quickSurveys' | translate}}</p>
      </section>
      <section class="participate-box">
        <mat-icon>stars</mat-icon>
        <h6 class="h-font">{{'xppoints' | translate}}</h6>
        <p>{{'inAppGoals' | translate}}</p>
      </section>
      <section class="participate-box">
        <mat-icon>groups</mat-icon>
        <h6 class="h-font">{{'community' | translate}}</h6>
        <p>{{'_comingSoon' | translate}}</p>
      </section>
      <section class="participate-box">
        <mat-icon>where_to_vote</mat-icon>
        <h6 class="h-font">{{'poll' | translate}}</h6>
        <p>{{'_comingSoon' | translate}}</p>
      </section>
    </div>
  </section>


  <!-- Happy Stories -->
  <!-- <section class="happy-row">
    <div class="happy-row-background"></div>
    <div class="happy-container">
      <h4 class="participate-hed">
        <div class="hifen"></div>
        <section class="story-box">
          <div>Happy Stories</div>
          <div id="happyStoriesIndicators" class="carousel slide">
            <section class="carousel-indicators">
              <button type="button" data-bs-target="#happyStoriesIndicators" data-bs-slide-to="0" class="active"
                aria-current="true" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#happyStoriesIndicators" data-bs-slide-to="1"
                aria-label="Slide 2"></button>
            </section>

            <section class="carousel-inner">
              <div class="carousel-item active">
                <div class="story-card">
                  <div class="card-conatiner">
                    <mat-card class="story-card-box" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="card-title">
                          <section class="card-hed">
                            <img src="../../../assets/images/men.webp"
                              alt="Photo of a Shiba Inu">
                            <div class="text-start">
                              <h5>Oliver Mitchell</h5>
                              <p>SF, USA</p>
                            </div>
                            <div class="text-start">
                              rating
                            </div>

                          </section>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="story-card-content">
                        “Anna, born in Arizona, USA really liked the ease of
                        taking surveys.”
                      </mat-card-content>
                    </mat-card>
                  </div>
                  <div class="card-conatiner">
                    <mat-card class="story-card-box" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="card-title">
                          <section class="card-hed">
                            <img src="../../../assets/images/men.webp"
                              alt="Photo of a Shiba Inu">
                            <div class="text-start">
                              <h5>Oliver Mitchell</h5>
                              <p>SF, USA</p>
                            </div>
                            <div class="text-start">
                              rating
                            </div>

                          </section>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="story-card-content">
                        “Anna, born in Arizona, USA really liked the ease of
                        taking surveys.”
                      </mat-card-content>
                    </mat-card>
                  </div>

                  <div class="card-conatiner">
                    <mat-card class="story-card-box" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="card-title">
                          <section class="card-hed">
                            <img src="../../../assets/images/men.webp"
                              alt="Photo of a Shiba Inu">
                            <div class="text-start">
                              <h5>Oliver Mitchell</h5>
                              <p>SF, USA</p>
                            </div>
                            <div class="text-start">
                              rating
                            </div>

                          </section>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="story-card-content">
                        “Anna, born in Arizona, USA really liked the ease of
                        taking surveys.”
                      </mat-card-content>
                    </mat-card>
                  </div>

                </div>
              </div>
              <div class="carousel-item">
                <div class="story-card">
                  <div class="card-conatiner">
                    <mat-card class="story-card-box" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="card-title">
                          <section class="card-hed">
                            <img src="../../../assets/images/men.webp"
                              alt="Photo of a Shiba Inu">
                            <div class="text-start">
                              <h5>Oliver Mitchell</h5>
                              <p>SF, USA</p>
                            </div>
                            <div class="text-start">
                              rating
                            </div>

                          </section>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="story-card-content">
                        “Anna, born in Arizona, USA really liked the ease of
                        taking surveys.”
                      </mat-card-content>
                    </mat-card>
                  </div>
                  <div class="card-conatiner">
                    <mat-card class="story-card-box" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="card-title">
                          <section class="card-hed">
                            <img src="../../../assets/images/men.webp"
                              alt="Photo of a Shiba Inu">
                            <div class="text-start">
                              <h5>Oliver Mitchell</h5>
                              <p>SF, USA</p>
                            </div>
                            <div class="text-start">
                              rating
                            </div>

                          </section>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="story-card-content">
                        “Anna, born in Arizona, USA really liked the ease of
                        taking surveys.”
                      </mat-card-content>
                    </mat-card>
                  </div>

                  <div class="card-conatiner">
                    <mat-card class="story-card-box" appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="card-title">
                          <section class="card-hed">
                            <img src="../../../assets/images/men.webp"
                              alt="Photo of a Shiba Inu">
                            <div class="text-start">
                              <h5>Oliver Mitchell</h5>
                              <p>SF, USA</p>
                            </div>
                            <div class="text-start">
                              rating
                            </div>

                          </section>
                        </mat-card-title>
                      </mat-card-header>
                      <mat-card-content class="story-card-content">
                        “Anna, born in Arizona, USA really liked the ease of
                        taking surveys.”
                      </mat-card-content>
                    </mat-card>
                  </div>

                </div>
              </div>
            </section>

            <button class="carousel-control-prev" type="button" data-bs-target="#happyStoriesIndicators"
              data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#happyStoriesIndicators"
              data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </section>
      </h4>
    </div>

  </section> -->

  <!-- Popular rewards -->
  <section class="popular-row">
    <h4 class="participate-hed">
      <div class="hifen"></div>
      <section>
        <div>{{'popularRewards' | translate}}</div>
        <p class="happy-hed-footer mt-2">{{'exploreOurCurrated' | translate}}</p>
      </section>
    </h4>

    <div class="happy-content">
      <div id="carouselExampleIndicators" class="carousel slide">
        <!-- <section class="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
            aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
            aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
            aria-label="Slide 3"></button>
        </section> -->

        <section class="carousel-inner">
          <div class="carousel-item active">
            <div class="row h-reward-box">
              <div class="col-md-4 col-sm-12 reward-content">
                <img src="../../../assets/images/Tango_reward.jpg" alt="tango-card">
                <p class="reward-f">{{'tangoCard' | translate}}</p>
              </div>
              <div class="col-md-4 col-sm-12 reward-content">
                <img class="paypal-reward-img"
                  src="../../../assets/images/paypal.webp" alt="paypal">
                <p class="reward-f">{{'paypal' | translate}}</p>
              </div>
              <div class="col-md-4 col-sm-12 reward-content">
                <img src="../../../assets/images/virtual-card.png" alt="Virtual Card">
                <p class="reward-f">{{'virtualMasterCard' | translate}}</p>
              </div>
            </div>
          </div>
        </section>

        <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button> -->
      </div>
    </div>

  </section>

  <!-- Footer rewards -->
  <footer class="footer-row">
    <div class="footer-content">
      <section class="footer-box">
        <!-- Help Section -->
        <section class="participate-box">
          <h5>{{'needAnyHelp' | translate}}</h5>
          <ul class="footer-help">
            <!-- <li>
              <h6>Call 24/7 for any help</h6>
              <p>+00 123 456 789</p>
            </li> -->
            <li>
              <h6>{{'mailToSupport' | translate }}</h6>
              <a class="text-danger" href="mailto:support@opinion-edge.com">{{'support@opinion-edge.com'}}</a>
            </li>
            <li>
              <div class="download-app hm-ft">
                <!-- <section class="d-flex justify-content-center">
              <div id="googleSignInDiv"></div>
            </section> -->
                <a href="https://play.google.com/store/apps/details?id=com.unipanel&pli=1" target="_blank">
                  <img src="../../../../../assets/images/playstore.png" alt="downlaod-with-playstore">
                </a>
                <a href="https://apps.apple.com/us/app/opinion-edge/id6446476343" target="_blank">
                  <img src="../../../../../assets/images/App-Store.png" alt="downlaod-with-appstore">
                </a>
              </div>
            </li>

            <!-- <li>
                    <h6>Follow us on</h6>
                    <ul class="social-icons">
                      <li>
                        <a href="https://www.facebook.com/opinionedge" target="_blank" aria-label="Facebook">
                          <mat-icon>facebook</mat-icon>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/opinionedge" target="_blank" aria-label="Instagram">
                          <mat-icon>instagram</mat-icon>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/opinion-edge" target="_blank" aria-label="LinkedIn">
                          <mat-icon>linkedin</mat-icon>
                        </a>
                      </li>
                    </ul>
                  </li> -->
          </ul>
        </section>

        <!-- Company Section -->
        <section class="participate-box">
          <h5>{{'company' | translate}}</h5>
          <ul>
            <li><a routerLink="/about" (click)="scrollToTop()">{{'aboutUs' | translate}}</a></li>
            <li><a routerLink="/contact-us" (click)="scrollToTop()">{{'contactUs' | translate}}</a></li>
          </ul>
        </section>

        <!-- Support Section -->
        <section class="participate-box">
          <h5>{{'_support' | translate}}</h5>
          <ul>
            <li><a routerLink="/faqs" (click)="scrollToTop()">{{'faqs' | translate}}</a></li>
            <li><a routerLink="/privacy-policy" (click)="scrollToTop()">{{'privacyPolicy' | translate}}</a></li>
            <li><a routerLink="/privacy-policy/terms-conditions" (click)="scrollToTop()">{{'termsConditions' |
                translate}}</a></li>

          </ul>
        </section>

        <!-- Top Cities Section -->
        <!-- <section class="participate-box">
          <h5>{{'topCities' | translate}}</h5>
          <ul>
            <li>United States</li>
            <li>Canada</li>
            <li>Australia</li>
            <li>France</li>
            <li>Germany</li>
          </ul>
        </section> -->
      </section>
      <mat-divider></mat-divider>
    </div>

    <section class="footer-bottom">
      <p class="text-red text-hed">{{'copyright' | translate}} &copy; {{'allRightsReserved' | translate}}</p>
      <span class="layout-logo" (click)="scrollToTop()">
        <img class="logo-full" loading="lazy" src="/logo-op.png" alt="logo">
      </span>
    </section>
  </footer>

</div>
<!-- <div class="home-festival-header left"></div> -->
<div class="home-festival-header-right"></div>
<!-- <app-chat-bot
  [botName]="'SurveySense AI'"
  [welcomeMessage]="'welcomeMess' | translate"
  [countryCode]="countryCode"
></app-chat-bot> -->